// extracted by mini-css-extract-plugin
module.exports = {"question-icon":"P_cN","questionIcon":"P_cN","total-title":"P_cP","totalTitle":"P_cP","total":"P_cG","total-summary":"P_cQ","totalSummary":"P_cQ"};